import { useStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { createStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useShallow as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
import { devtools as r } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/middleware.mjs";
//#region src/lib/stores/spaces-store/useSpacesStore.ts
var i = t(r((e) => ({
	searchedSpaceTerm: "",
	isSearchingSpaceTerm: !1,
	clear: () => e({
		searchedSpaceTerm: "",
		isSearchingSpaceTerm: !1
	}),
	setIsSearching: (t) => e({ isSearchingSpaceTerm: t }),
	setSearchedSpaceTerm: (t = "") => e({ searchedSpaceTerm: t })
}))), a = (t) => e(i, n(t));
//#endregion
export { i as spacesStore, a as useSpacesStore };
